import DataGrid, { Column, Editing, Paging, SearchPanel } from 'devextreme-react/data-grid';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, Input } from 'reactstrap';
import { useAuth } from '../../../auth';
import Breadcrumb from '../../../components/common/breadcrumb';
import { getBlockingTypes, saveBlockingType } from './api';

// Blockage types (tender rows 58–61): which operations each type blocks. Used by Veri Yükleme > Genel Blokaj
// ("Blokaj Tipi" column), the groupage checks and the gate / transfer exit check. Changes take effect at once and are
// logged with who / when. System types are set by other processes (dealer request, customs), not by the upload.
// Role group 'Tanımlamalar - Blokaj Tipleri' (db-migrations/016_blocking_type_roles.sql).
const ROLE_GROUP = 34;

const BlokajTipleri = () => {
    const { hasRole } = useAuth(ROLE_GROUP);
    const canEdit = hasRole('blokaj_tipi_write');
    const [rows, setRows] = useState([]);
    const load = useCallback(() => {
        getBlockingTypes().then(setRows).catch((e) => toast.error(e?.response?.data?.error || 'Blokaj tipleri alınamadı'));
    }, []);
    useEffect(load, [load]);

    const persist = (code, values) => saveBlockingType(code, values)
        .then(() => { toast.success('Kaydedildi'); load(); return false; })
        .catch((e) => { toast.error(e?.response?.data?.error || 'Kaydedilemedi'); return true; });

    return (
        <>
            <Breadcrumb parent="Tanımlamalar" current="Blokaj Tipleri" />
            <Card><CardBody>
                <p className="mb-2">
                    Genel Blokaj yüklemesindeki <b>Blokaj Tipi</b> kolonunda kod veya ad yazılır. Bir araçta birden fazla tip
                    aynı anda aktif olabilir; işaretli işlemlerden biri en az bir aktif tipte engelliyse işlem yapılamaz.
                    <b> Sistem</b> tipleri başka süreçlerden gelir (bayi talebi: Blokaj/Sevk Yeri Değişikliği, gümrük: milli/ithal
                    durumu) ve yüklemeyle eklenemez. Değişiklikler kod geliştirmeden geçerli olur ve kim/ne zaman bilgisiyle loglanır.
                </p>
                <DataGrid dataSource={rows} keyExpr="code" showBorders columnAutoWidth wordWrapEnabled
                    onRowUpdating={(e) => { e.cancel = persist(e.key, e.newData); }}
                    onRowInserting={(e) => { const { code, ...values } = e.data; e.cancel = persist(code, values); }}>
                    <Editing mode="row" allowUpdating={canEdit} allowAdding={canEdit} />
                    <Paging pageSize={20} />
                    <SearchPanel visible />
                    <Column dataField="code" caption="Kod" allowEditing={false} width={140}
                        editCellRender={(c) => (c.row.isNewRow ? <Input maxLength={20} onChange={(e) => c.setValue(e.target.value.toUpperCase())} /> : c.value)} />
                    <Column dataField="name_tr" caption="Ad (TR)" />
                    <Column dataField="name_en" caption="Ad (EN)" />
                    <Column dataField="released_by" caption="Kaldıran" />
                    <Column dataField="blocks_groupage" caption="Grupajı engeller" dataType="boolean" />
                    <Column dataField="blocks_gate_exit" caption="Kapı çıkışını engeller" dataType="boolean" />
                    <Column dataField="blocks_transfer" caption="Transferi engeller" dataType="boolean" />
                    <Column dataField="is_system" caption="Sistem" dataType="boolean" allowEditing={false} />
                    <Column dataField="is_active" caption="Aktif" dataType="boolean" />
                </DataGrid>
            </CardBody></Card>
        </>
    );
};

export default BlokajTipleri;
